export const _toString = Object.prototype.toString;
export const hasOwnProperty = Object.prototype.hasOwnProperty;

export function getValueFromNestedSource(sourceObject, paths) {
    return paths.reduce((object, path) => {
        return (object || {})[path]
    }, sourceObject)
}

export const isFalsyValue = v => !!v === false;

export const isUndef = v => v === undefined || v === null;

export const isDef = v => v !== undefined && v !== null;

export const isTrue = (v) => v === true;

export const isFalse = (v) => v === false;

export const isPrimitive = (value) => (typeof value === 'string' || typeof value === 'number' || typeof value === 'symbol' || typeof value === 'boolean');

export const isRefrence = (obj) => obj !== null && typeof obj === 'object';

export const isPlainArray = (arr) => _toString.call(arr) === '[object Array]';

export const isPlainObject = (obj) => _toString.call(obj) === '[object Object]';

export const isRegExp = (v) => _toString.call(v) === '[object RegExp]';

export const isFunction = (fn) => _toString.call(fn) === "[object Function]";

export const isPromise = (val) => isDef(val) && typeof val.then === 'function' && typeof val.catch === 'function';

export const isValidArrayIndex = (val) => {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
}

export const toNumber = (val) => {
    var n = parseFloat(val);
    return isNaN(n) ? val : n
}

export const remove = (arr, item) => {
    // remove a item from array
    if (arr.length) {
        var index = arr.indexOf(item);
        if (index > -1)
            return arr.splice(index, 1)
    }
}

export const extend = (to, _from) => {
    // * Mix properties into target object.
    for (var key in _from)
        to[key] = _from[key];
    return to
}

export const hasOwn = (obj, key) => hasOwnProperty.call(obj, key);

export const defineAproperty = (obj, key, val, enumerable) => {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true
    });
}
export const reset = ({ targetObject, initialObject }) => {
    Object.keys(targetObject).forEach(function (key) {
        targetObject[key] = initialObject[key];
    });
}
export const toDecimal = (val, decimal) => {
    var regExpr = /[^0-9.]/g;
    val = parseFloat(("" + val).replace(regExpr, ''))
    return (val || val === 0) ?
        decimal === undefined ?
            val :
            parseFloat(val.toFixed(toDecimal(decimal))) : null;
}

export const filter = (array, callback) => ([]).filter.call(array, callback);

export const loopMap = (array, callback) => ([]).map.call(array, callback);

export const mapOrder = (array, order, key) => {
    array.sort(function (a, b) {
        var A = a[key],
            B = b[key];
        if (order.indexOf(A) > order.indexOf(B)) {
            return 1;
        } else {
            return -1;
        }
    });
    return array;
};

export const groupBy = (xs, key, defaultVal) => {
    return xs.reduce((rv, x) => {
        const DEFAULT = (typeof defaultVal === "object"
            && typeof defaultVal[x[key]] === "object"
            && defaultVal[x[key]]);
        if (DEFAULT) x[DEFAULT.key] = x[DEFAULT.key] || DEFAULT.default;
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

export const sortArray = (array, key) => [...array].sort((a, b) => a[key] - b[key]);

export const debounce = function (fn, delay) {
    let timer;
    return function () {
        let context = this;
        let args = arguments;

        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(context, args), delay);
    };
};